import { IDynamicObject, ModelConstructor, setNumber } from "xa-generics";

/**
 * ## CourierOrderModel
 *
 * One order of the interval a courier close covers, as CourierSummary#orders_json returns it. The
 * close and the drop off list the same set, because both are added up from it.
 */
export class CourierOrderModel {
    constructor(rawData?: IDynamicObject<any>) {
        if (!rawData) return;
        const data = rawData as CourierOrderMData;
        ModelConstructor(data, this);

        this.price = setNumber(data.price);
        this.delivery_price = setNumber(data.delivery_price);

        //An order outside a priced region carries no address fee at all, which is not the same as 0
        this.courier_price = data.courier_price === null ? null : setNumber(data.courier_price);
    }

    id: string = "";
    name: string = "";
    address: string = "";
    payment_method: string = "";
    archived_at: string | null = null;
    price: number = 0;
    delivery_price: number = 0;
    courier_price: number | null = null;

    //A close can span several days, and moving an order asks which round it went out on
    show_at: string = "";
}

//If you add public methods, you may want to replace the empty string with them!
type CourierOrderMData = Partial<InstanceType<typeof CourierOrderModel>>;
